import getScenarioStore from '../selectors/getScenarioStore';
import { clearSearchBox } from '../actions/publicActions';
import { createDefaultSearchStore } from '../store/store';
import { ObservableMap } from 'mobx';
import { mutator } from 'satcheljs';
import { PillSuggestion } from 'owa-search-service';

export default mutator(clearSearchBox, actionMessage => {
    const store = getScenarioStore(actionMessage.scenarioId);
    const defaultSearchStore = createDefaultSearchStore();

    // Clear suggestion pills.
    store.suggestionPillIds = defaultSearchStore.suggestionPillIds;
    store.suggestionPills = new ObservableMap<string, PillSuggestion>();

    // Clear segments.
    store.suggestionSegments.clear();

    // Clear plain text search query.
    store.searchText = defaultSearchStore.searchText;
});
